import { NgModule }          from '@angular/core';
import { RouterModule }      from '@angular/router';

import { AuthGuard }               from '../services/auth.guard';
import { ProjectListComponent }    from './components/project-list.component';

const projectRoutes = [
  {
    path: 'projects',
    children: [
      {
        path: '',
        component: ProjectListComponent,
        pathMatch: 'full',
        canActivate: [ AuthGuard ],
        data: { tab_name: 'projects' }
      }
    ]
  }
];

@NgModule({
  imports: [ RouterModule.forChild(projectRoutes) ],
  exports: [ RouterModule ],
})

export class ProjectRoutingModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/projects/project-routing.module.ts